export default __webpack_public_path__ + "static/media/man.ba3e9327.png";